import { patientApi } from "src/api/services/patientApi";
import { store } from "src/app/store";
import { authLoader } from "./authLoader";

export const getMeLoader = async () => {
  return authLoader(() =>
    store.dispatch(patientApi.endpoints.getMe.initiate()),
  );
};
